import { render, staticRenderFns } from "./CreateReviewModal.vue?vue&type=template&id=f5e8121e&scoped=true&"
import script from "./CreateReviewModal.vue?vue&type=script&lang=js&"
export * from "./CreateReviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e8121e",
  null
  
)

export default component.exports